export default function CTABanner() {
  return (
    <section className="relative min-h-[400px] md:min-h-[480px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Top%20down%20flat%20lay%20of%20fashion%20shopping%20essentials%20including%20smartphone%20displaying%20product%20grid%20sneakers%20sunglasses%20wallet%20and%20coffee%20arranged%20on%20warm%20wooden%20table%2C%20lifestyle%20ecommerce%20concept%20photography%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20cozy%20organized%20desk%20aesthetic%2C%20warm%20beige%20and%20cream%20tones&width=1600&height=800&seq=cta-banner-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet Fashion Shopping"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl lg:text-5xl text-background-50 mb-4 leading-tight">
            Bereit für die besten Fashion-Funde?
          </h2>
          <p className="text-base md:text-lg text-background-100 max-w-xl mx-auto mb-8">
            Stöbere durch 3.000+ kuratierte Produkte von verifizierten Verkäufern.
            Kostenlos nutzbar, täglich aktualisiert.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              OOPBuy Spreadsheet
              <span className="w-5 h-5 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full text-sm font-semibold bg-background-50 text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}